declare const window: any;

export const isWebview = () => {
  const standalone = window.navigator.standalone;
  const userAgent = window.navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);

  if (userAgent.includes('wv') || (ios && !standalone && !safari)) {
    return true;
  } else {
    return false;
  }
};